import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TickrComponent } from './components/tickr/tickr.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [TickrComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    TickrComponent
  ]
})
export class TickrModule { }
